import * as React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function HeroSection() {
  return <section id="hero-section" className="relative w-full min-h-[350px] md:min-h-[450px] lg:min-h-[500px] flex items-center py-12">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/workshop_tools_background.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/workshop_tools_background.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/workshop_tools_background.png-wvc-sizes" alt="Workshop with tools" className="w-full h-full object-cover object-center" loading="eager" />
        <div className="absolute inset-0 bg-black/75" aria-hidden="true" />
      </div>

      {}
      <div className="page-container relative z-10 flex flex-col gap-6">
        <Breadcrumb>
          <BreadcrumbList className="text-white/70 sm:gap-2">
            <BreadcrumbItem>
              <BreadcrumbLink asChild className="hover:text-white transition-colors">
                <Link to="/">Startseite</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-white/50" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-white font-medium">
                Leistungen
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight">
          Unsere Leistungen
        </h1>
      </div>
    </section>;
}